import { useRouter } from 'next/router';

import { VoucherProvider } from 'blocks/e-gift-card/buy/context';

import PageService from 'services/PageService/PageService';

import DownloadApp from 'blocks/DownloadApp/DownloadApp';
import Payment from 'blocks/e-gift-card/buy/payment';
import FormList from 'blocks/e-gift-card/buy/form/form-list';
import Layout from 'blocks/e-gift-card/buy/layout';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';

import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';

import type { NextPage, GetStaticProps, InferGetStaticPropsType } from 'next';
import type { IGlobalLayout } from 'types/interfaces';
import GiftCardService from 'services/GiftCardService/GiftCardService';
import { GiftCard } from 'types/types';


type VouchersPageProps = InferGetStaticPropsType<typeof getStaticProps>;

type VouchersProps = {
  globalLayoutProps: IGlobalLayout;
  currencies: IGlobalLayout['currencies'];
  customGiftCards: GiftCard[];
};

const Vouchers: NextPage<VouchersPageProps> = ({
  globalLayoutProps,
  currencies,
  customGiftCards,
}) => {
  const router = useRouter();
  const {
    query: { step },
  } = router;

  return (
    <GlobalLayout {...globalLayoutProps}>
      <VoucherProvider currencies={currencies} customGiftCards={customGiftCards}>
        <Layout>
          {step === 'form' || (!step && <FormList />)}
          {step === 'payment' && <Payment />}
        </Layout>
      </VoucherProvider>

      <DownloadApp />
    </GlobalLayout>
  );
};

export default Vouchers;

export const getStaticProps: GetStaticProps<VouchersProps> = async () => {
  const { globalLayoutProps } = await PageService.getGenericPageProps({
    navPath: navigationPaths.E_GIFT_CARD,
  });

  const customGiftCards = await GiftCardService.getCards();
  
  const { currencies } = globalLayoutProps;

  return {
    props: {
      globalLayoutProps,
      currencies,
      customGiftCards,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
